module.exports = __webpack_public_path__ + "img/nav-Tip-Gray.59594c67.png";